import { styled } from 'styled-components';

import { DropdownListMenuItem } from '#/components/Dropdown/menus/ListMenu/DropdownListMenuItem';
import { colors } from '#/theme/theme';

export const WorkspaceDropdownButtonContent = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;

  &[data-wide] {
    width: 300px;
  }

  .workspace-text {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &:not([data-wide]) .workspace-text {
    width: 100px;
  }
`;

export const WorkspaceDropdownProMemberBadgeContainer = styled.div`
  margin: 0 8px;
`;

export const WorkspaceDropdownListMenuItem = styled(DropdownListMenuItem)<{
  $selected: boolean;
}>`
  gap: 8px;
  background-color: ${(props) =>
    props.$selected ? colors.selectionBlue : 'transparent'};
`;
